import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=0dbd7db5&scoped=true&"
import script from "./TermsCondition.vue?vue&type=script&lang=ts&"
export * from "./TermsCondition.vue?vue&type=script&lang=ts&"
import style0 from "./TermsCondition.vue?vue&type=style&index=0&id=0dbd7db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd7db5",
  null
  
)

export default component.exports